module.exports = __webpack_public_path__ + "487552bf5cac7fde6b9937e6197e6ccf.pdf";